import { post } from 'services/http';

const editVkl = (kgId, vkl, userPrompts, filePath) =>
  post(`/studio/api/knowledge-graphs/${encodeURIComponent(kgId)}/copilot/edit-vkl`, { vkl, filePath, userPrompts });

export default {
  editVkl
};
